import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search, Send, Package, User, Clock } from 'lucide-react';
import { Header } from '../components/ui/Header';
interface Message {
  id: string;
  buyerName: string;
  buyerAvatar?: string;
  lastMessage: string;
  timestamp: string;
  unread: number;
  orderId?: string;
}
export function VendorMessagesScreen() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedChat, setSelectedChat] = useState<string | null>(null);
  // Mock messages
  const messages: Message[] = [{
    id: 'M1',
    buyerName: 'John Doe',
    lastMessage: 'Is the iPhone still available?',
    timestamp: new Date().toISOString(),
    unread: 2,
    orderId: 'VO-001'
  }, {
    id: 'M2',
    buyerName: 'Jane Smith',
    lastMessage: 'When will my order be shipped?',
    timestamp: new Date(Date.now() - 3600000).toISOString(),
    unread: 0,
    orderId: 'VO-002'
  }, {
    id: 'M3',
    buyerName: 'Mike Johnson',
    lastMessage: 'Do you have this in black?',
    timestamp: new Date(Date.now() - 7200000).toISOString(),
    unread: 1
  }];
  const filteredMessages = messages.filter(msg => msg.buyerName.toLowerCase().includes(searchQuery.toLowerCase()));
  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="min-h-screen bg-gray-50 pb-24" data-id="element-2040">
      <Header title="Messages" showBack={false} data-id="element-2041" />

      {/* Search */}
      <div className="bg-white p-4 border-b border-gray-100 sticky top-[53px] z-30" data-id="element-2042">
        <div className="relative" data-id="element-2043">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-2044" />
          <input type="text" placeholder="Search conversations..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" data-id="element-2045" />
        </div>
      </div>

      {/* Messages List */}
      <div className="divide-y divide-gray-100" data-id="element-2046">
        {filteredMessages.length > 0 ? filteredMessages.map((msg, idx) => <motion.button key={msg.id} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: idx * 0.05
      }} onClick={() => setSelectedChat(msg.id)} className="w-full bg-white p-4 flex items-start gap-3 hover:bg-gray-50 active:bg-gray-100 transition-colors" data-id="element-2047">
              {/* Avatar */}
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center text-primary flex-shrink-0" data-id="element-2048">
                <User className="w-6 h-6" data-id="element-2049" />
              </div>

              {/* Message Content */}
              <div className="flex-1 min-w-0 text-left" data-id="element-2050">
                <div className="flex items-center justify-between mb-1" data-id="element-2051">
                  <h3 className="font-medium text-gray-900" data-id="element-2052">{msg.buyerName}</h3>
                  <span className="text-xs text-gray-500" data-id="element-2053">
                    {formatTime(msg.timestamp)}
                  </span>
                </div>

                {msg.orderId && <div className="flex items-center gap-1 mb-1" data-id="element-2054">
                    <Package className="w-3 h-3 text-gray-400" data-id="element-2055" />
                    <span className="text-xs text-gray-500" data-id="element-2056">{msg.orderId}</span>
                  </div>}

                <p className={`text-sm truncate ${msg.unread > 0 ? 'text-gray-900 font-medium' : 'text-gray-500'}`} data-id="element-2057">
                  {msg.lastMessage}
                </p>
              </div>

              {/* Unread Badge */}
              {msg.unread > 0 && <div className="w-5 h-5 bg-primary rounded-full flex items-center justify-center flex-shrink-0" data-id="element-2058">
                  <span className="text-xs font-bold text-white" data-id="element-2059">
                    {msg.unread}
                  </span>
                </div>}
            </motion.button>) : <div className="flex flex-col items-center justify-center py-12 text-center px-4" data-id="element-2060">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-2061">
              <Send className="w-10 h-10 text-gray-400" data-id="element-2062" />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-2063">
              No Messages
            </h3>
            <p className="text-sm text-gray-500" data-id="element-2064">
              Customer messages will appear here
            </p>
          </div>}
      </div>
    </motion.div>;
}